import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '快速导航',
    links: [
      { to: '/', label: '首页' },
      { to: '/category/rexue', label: '动漫分类' },
      { to: '/about', label: '关于我们' },
    ],
  },
  {
    title: '热门分类',
    links: [
      { to: '/category/rexue', label: '热血动漫' },
      { to: '/category/lianai', label: '恋爱动漫' },
      { to: '/category/qihuan', label: '奇幻动漫' },
      { to: '/category/gaoxiao', label: '搞笑动漫' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { to: '/about', label: '品牌介绍' },
      { to: '/about', label: '联系我们' },
      { to: '/about', label: '用户口碑' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-secondary-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-flower-line text-xl text-primary-500"></i>
              </div>
              <span className="font-heading text-lg text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                樱花动漫之家
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              专注手机动漫的门户网站，让您随时随地在线免费观看动漫，享受便捷的移动端动漫体验。
            </p>
          </div>

          {footerLinks.map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-medium text-foreground-950 mb-3">
                {section.title}
              </h4>
              <ul className="flex flex-col gap-2">
                {section.links.map((link, idx) => (
                  <li key={idx}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 樱花动漫之家. 本站内容仅供学习交流使用.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}